export const AUTHORIZATION = "Authorization";
export const NEXT_LOCALE = "NEXT_LOCALE";
export const PSP_COOKIE = "psp";
export const MID_COOKIE = "mid";
export const UTMS = "utms";
export const FEEDBACK_MODAL_DISMISSED = "feedback_modal_dismissed";
export const AMPLITUDE_DEVICE_ID_COOKIE = "amplitude_device_id";
